import { normalizeState } from './stateColors';

const STARTABLE_STATES = new Set(['stopped', 'disconnected', 'failed']);
const CONTROLLABLE_STATES = new Set(['connected', 'synchronizing', 'ready']);
const TRANSITIONAL_STATES = new Set([
  'starting',
  'connecting',
  'stopping',
  'restarting',
  'reconnecting',
  'halting',
]);
const PAIRING_STATES = new Set(['unprepared', 'unverified']);

/**
 * Maps a QuePasa connection state to the controls that are safe to expose.
 * `Unreachable` is generated by Hermes when the service cannot be contacted,
 * so it must never expose a mutating session action.
 */
export const getSessionActionPolicy = state => {
  const normalizedState = normalizeState(state);

  return {
    canStart: STARTABLE_STATES.has(normalizedState),
    canStop: CONTROLLABLE_STATES.has(normalizedState),
    canRestart: CONTROLLABLE_STATES.has(normalizedState),
    isServiceUnavailable: normalizedState === 'unreachable',
    isTransitioning: TRANSITIONAL_STATES.has(normalizedState),
    requiresPairing: PAIRING_STATES.has(normalizedState),
  };
};
